import { apiBaseUrl } from "../../configs/app";
import Invoice from "../../types/shop/invoice.type";
import CryptoService from "../crypto.services";
import loginService from "../loginService";

function getKey(id: string, myOrders: boolean = false) {
    return CryptoService.hash("invoice-" + id + "-myOrders-" + myOrders)
}
export function getInvoice(id: string, myOrders: boolean = false) {
    const localStorageKey = getKey(id, myOrders)
    const localData = window.localStorage.getItem(localStorageKey)
    return (localData ? JSON.parse(CryptoService.decrypt(localData)) as Invoice : null)
}
export function fetchInvoice(id: string, myOrders: boolean = false) {
    const localStorageKey = getKey(id, myOrders)
    const url = apiBaseUrl + `invoices/${id}` + (myOrders ? '?my_orders=1' : '')
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", "Bearer " + loginService.currentUser.token);

    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    } as RequestInit;
    return fetch(url, requestOptions).then((res) => res.json())
        .then((res: Invoice) => {
            if (res && res.invoice_id) {
                window.localStorage.setItem(localStorageKey, CryptoService.encrypt(JSON.stringify(res)))
                return res as Invoice
            } else {
                return null
            }
        })
}
